<div
  class="step-icon bg--default f--4 bold"
  [class.bg--dark]="active"
  [class.color--light]="active"
>
  <span *ngIf="!completed; else completedIcon">{{ idx + 1 }}</span>
</div>

<div
  *ngIf="label != null"
  class="pl--2 f--4 bold"
  [class.color--heading-dark]="active"
>
  {{ label }}
</div>

<ng-template #completedIcon> <ta-icon icon="ok"></ta-icon> </ng-template>
